/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Symbol status enum matching database
 */
export enum SymbolStatusDb {

    Active = 'active',

    Inactive = 'inactive',

    Delisted = 'delisted',

    Maintenance = 'maintenance'
}
